const NotFound = () => {
  return (
    <div class="flex items-center justify-center h-screen bg-gray-100">
      <div class="text-center">
        <h1 class="text-4xl font-bold text-gray-800">404</h1>
        <p class="text-xl text-gray-600 mt-4">Credencial no encontrada</p>
        <p class="text-md text-gray-500 mt-2">
          No pudimos encontrar el certificado que buscas. Por favor, verifica el ID e inténtalo de nuevo.
        </p>
        <a href="/" class="mt-6 inline-block bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition-colors">
          Volver al inicio
        </a>
      </div>
    </div>
  );
};

export default NotFound;
